import paydayAssets from '../scenes/SalesPages/PayDay/payDayImages';
import valentinesDayAssets from '../scenes/SalesPages/ValentinesDayOffers/ValentinesDayImages';

export const OFFERS_PAGE_DATA = {
  valentines_day_banner: {
    imageUrl: valentinesDayAssets?.valentinesDayHeroBanner,
    eventName: '',
  },
  close: {
    imageUrl: paydayAssets?.close,
  },
  rewards: [
    {
      imageUrl: valentinesDayAssets?.rewards?.reliance,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 1,
      name: 'Reliance Fresh',
      inApp: true,
    },
    {
      imageUrl: valentinesDayAssets?.rewards?.cobb,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 2,
      name: 'Cobb',
      inApp: true,
    },
    {
      imageUrl: valentinesDayAssets?.rewards?.barista,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 3,
      name: 'Barista',
      inApp: true,
    },
    {
      imageUrl: valentinesDayAssets?.rewards?.wow,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 4,
      name: 'Wow Momos',
      inApp: true,
    },
    {
      imageUrl: valentinesDayAssets?.rewards?.mcd,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 5,
      name: 'Mc Donalds',
      inApp: true,
    },
    {
      imageUrl: valentinesDayAssets?.rewards?.pizzahut,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 6,
      name: 'Pizza Hut',
      inApp: true,
    },
    {
      imageUrl: valentinesDayAssets?.rewards?.bikernerwala,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 7,
      name: 'Bikernervala',
      inApp: true,
    },
    {
      imageUrl: valentinesDayAssets?.rewards?.archies,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 8,
      name: 'Archies',
      inApp: true,
    },
    {
      imageUrl: valentinesDayAssets?.rewards?.manCompany,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 9,
      name: 'Tha Man Company',
      inApp: true,
    },
  ],
  verifiedBy: [
    {
      logoUrl: paydayAssets?.secure?.verified,
    },
    {
      logoUrl: paydayAssets?.secure?.secure,
    },
    {
      logoUrl: paydayAssets?.secure?.reserve,
    },
  ],
  // redirection link
  app: [
    {
      logoUrl: paydayAssets?.app?.earn,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 1,
      name: 'TWID Stars',
      inApp: true,
    },
    {
      logoUrl: paydayAssets?.app?.reward,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 2,
      name: 'Scan and Pay',
      inApp: true,
    },
    {
      logoUrl: paydayAssets?.app?.ixigo,
      redirectUrl: 'https://f.ixigo.com/Zb6T-gGZFAw6',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 3,
      name: 'Ixigo',
      inApp: false,
    },
  ],
  valentinesDayCategories: [
    {
      imageUrl: valentinesDayAssets?.categories?.food,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 1,
      name: 'Food & Groceries',
    },
    {
      imageUrl: valentinesDayAssets?.categories?.travel,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 2,
      name: 'Travel',
    },
    {
      imageUrl: valentinesDayAssets?.categories?.shopping,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 3,
      name: 'Shopping',
    },
    {
      imageUrl: valentinesDayAssets?.categories?.electronics,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 4,
      name: 'Electronics',
    },
    {
      imageUrl: valentinesDayAssets?.categories?.entertainment,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 5,
      name: 'Entertainment',
    },
  ],
  valentinesDayBrandsInSpotlight: [
    {
      imageUrl:
        valentinesDayAssets?.valentinesDaySpotlightBrands?.spotlight_brand_1,
      redirectUrl: 'https://www.swiggy.com//',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 1,
      name: 'Swiggy',
      inApp: false,
    },
    {
      imageUrl:
        valentinesDayAssets?.valentinesDaySpotlightBrands?.spotlight_brand_2,
      redirectUrl: 'https://jiomart.onelink.me/Qg0u/twidpay%5C',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 2,
      name: 'JioMart',
      inApp: false,
    },
    {
      imageUrl:
        valentinesDayAssets?.valentinesDaySpotlightBrands?.spotlight_brand_3,
      redirectUrl: 'https://www.swiggy.com/instamart',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 3,
      name: 'Instamart',
      inApp: false,
    },
    {
      imageUrl:
        valentinesDayAssets?.valentinesDaySpotlightBrands?.spotlight_brand_4,
      redirectUrl: 'https://www.abhibus.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 4,
      name: 'AbhiBus',
      inApp: false,
    },
    {
      imageUrl:
        valentinesDayAssets?.valentinesDaySpotlightBrands?.spotlight_brand_5,
      redirectUrl: 'https://www.eatsure.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 5,
      name: 'EatSure',
      inApp: false,
    },
    {
      imageUrl:
        valentinesDayAssets?.valentinesDaySpotlightBrands?.spotlight_brand_6,
      redirectUrl: 'https://www.redbus.in/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 6,
      name: 'Redbus',
      inApp: false,
    },
    {
      imageUrl:
        valentinesDayAssets?.valentinesDaySpotlightBrands?.spotlight_brand_7,
      redirectUrl: 'https://www.easemytrip.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 7,
      name: 'EaseMyTrip',
      inApp: false,
    },
    {
      imageUrl:
        valentinesDayAssets?.valentinesDaySpotlightBrands?.spotlight_brand_8,
      redirectUrl: 'https://www.themancompany.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 8,
      name: 'The Man Company',
      inApp: false,
    },
  ],
  valentinesDayOtherBrands: [
    {
      logoUrl:
        valentinesDayAssets?.valentinesDayOtherBrands?.otherBrands_ConfirmTkt,
      redirectUrl: '/offers/confirmtkt',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'ConfirmTkt',
    },
    {
      logoUrl:
        valentinesDayAssets?.valentinesDayOtherBrands?.otherBrands_BookMyShow,
      redirectUrl: '/offers/bookmyshow',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'BookMyShow',
    },
    {
      logoUrl:
        valentinesDayAssets?.valentinesDayOtherBrands?.otherBrands_Zeeraki,
      redirectUrl: '/offers/zeeraki',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'Zeeraki Jewels',
    },
    {
      logoUrl:
        valentinesDayAssets?.valentinesDayOtherBrands?.otherBrands_Netmeds,
      redirectUrl: '/offers/netmeds',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'Netmeds',
    },
    {
      logoUrl:
        valentinesDayAssets?.valentinesDayOtherBrands?.otherBrands_JustHerbs,
      redirectUrl: '/offers/justherbs',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'JustHerbs',
    },
  ],
  valentinesDayAppExclusive: [
    {
      logoUrl: valentinesDayAssets?.valentinesDayAppExclusive?.ssae_TwidStars,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 1,
      name: 'TWID Stars',
      inApp: true,
    },
    {
      logoUrl:
        valentinesDayAssets?.valentinesDayAppExclusive?.ssae_TwidScanAndPay,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 2,
      name: 'Scan and Pay',
      inApp: true,
    },
    {
      logoUrl: valentinesDayAssets?.valentinesDayAppExclusive?.ssae_Ixigo,
      redirectUrl: 'https://f.ixigo.com/Zb6T-gGZFAw6',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 3,
      name: 'Ixigo',
      inApp: false,
    },
  ],
};
